import OrderSubscriptionHeader from "../../components/OrderSubscriptionHeader";
import HorizontalLinearStepper from "../../components/Atoms/HorizontalLinearStepper";

export default function OrderSubscriptionPage() {
  return (
    <>
      <OrderSubscriptionHeader />
      <div className="stepper" id="stepper">
        <HorizontalLinearStepper />
      </div>
     
    </>
  );
}
